import type { EnvironmentConfig } from "./development";

/**
 * Staging environment configuration
 */
export const stagingConfig: EnvironmentConfig = {
  // API Configuration
  apiTimeout: 45000,
  enableMockData: false,
  enableDebugMode: false,

  // Logging Configuration
  logLevel: "warn",
  enableConsoleLogging: true,
  enableNetworkLogging: true,

  // Performance Configuration
  enablePerformanceMonitoring: true,
  enableSourceMaps: true,

  // Feature Flags
  features: {
    enableNewUI: true,
    enableExperimentalFeatures: true,
    enableBetaFeatures: true,
  },

  // Development Tools
  enableDevTools: false,
  enableHotReload: false,
  enableErrorBoundary: true,

  // Cache Configuration
  cacheTimeout: 20 * 60 * 1000, // 20 minutes
  enableCaching: true,
};
